import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './UserContext';

const ProtectedAdminRoute = ({ component }) => {
  const { user } = useContext(UserContext);

  if (user === 'admin') {
    return component; 
  } else {
    return <Navigate to="/" />; 
  }
};

export default ProtectedAdminRoute;
